<template>
  <div>
    <v-col cols="12" class="mx-auto">
      <div class="mx-auto">
        <v-btn
          v-if="displayBindingController"
          color="primary"
          outlined
          class="text-none mr-2"
          dark
          rounded
          @click="getPossibleDoorphones"
        >
          привязать домофон
        </v-btn>
      </div>
      <v-card-text v-if="displayMain">{{ displayCardText }}</v-card-text>
      <v-card-text v-if="!displayMain">Нет привязанных домофонов.</v-card-text>
      <v-data-table
        v-if="displayMain"
        class="table"
        item-key="id"
        :items="controller.doorphones"
        :items-per-page="5"
        :headers="headersAttachedDoorphones"
        :footer-props="{
            'items-per-page-options': [5, 10],
          }"
      >
        <template v-slot:item.address="{ item }">
          <router-link class="routerLink" :to="`/doorphones/${item.id}`">
            {{ getDoorphoneAddress(item) }}
          </router-link>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                text
                tile
                small
                v-bind="attrs"
                v-on="on"
                class="btn__icon pa-0"
                width="18"
                height="18"
                @click.stop="$set(dialogRemove, item.id, true)"
              >
                <v-icon size="large">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Отвязать домофон</span>
          </v-tooltip>
          <v-dialog v-model="dialogRemove[item.id]" width="500">
            <BaseDeleteModal
              :active.sync="dialogRemove[item.id]"
              @close="$set(dialogRemove, item.id, false)"
              @submit="excisionControllerDoorphone(item.id)"
              messageTitle="Отвязать домофон?"
              messageText="Подтверждая, вы отвяжите домофон."/>
          </v-dialog>
        </template>
      </v-data-table>
    </v-col>

    <v-dialog v-model="popupBindDoorphones" max-width="600" lazy-validation>
      <v-card class='pb-5'>
        <v-progress-linear v-if="loadingListDoorphones" indeterminate color="primary"></v-progress-linear>
        <v-card-title class="headline">
          Привязать домофон
          <v-spacer></v-spacer>
          <v-btn
            icon
            text
            x-large
            class="btn__icon pa-0"
            width="18"
            height="18"
            @click.prevent="popupBindDoorphones = false"
          >
            <v-icon size="x-large">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-col class="px-5 pb-5">
          <v-text-field
            v-model='serchValue'
            placeholder="Поиск по адресу"
            solo
            outlined
            dense
            hide-details
            flat
          ></v-text-field>
        </v-col>
        <v-col class="px-5 pb-5">
          <v-text-field
            v-model='serchValueId'
            placeholder="Поиск по id"
            solo
            outlined
            dense
            hide-details
            flat
          ></v-text-field>
        </v-col>
        <v-col class="px-5 pb-5">
          <v-btn
            color="primary"
            outlined
            class="text-none mr-2"
            rounded
            @click.prevent="addDoorphone()"
          >
            Привязать
          </v-btn>
        </v-col>
        <v-data-table
          class="table row-click mx-5 pb-5"
          :items-per-page="10"
          :items="searchFreeDoorphones"
          :headers="headersTieDoorphones"
          :footer-props="{
            'items-per-page-options': [10, 20, 50],
          }"
          item-key="id"
          show-select
          :multi-select="true"
          v-model="selected"
          @click:row="activateShowSelect"
        >
          <template v-slot:item.address="{ item }">
            {{ getDoorphoneAddress(item) }}
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAddDoorphone" max-width="350">
      <v-card>
        <v-card-title class="headline">Привязать домофон?</v-card-title>
        <v-card-text>Подтверждая, вы привязываете домофон.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click.prevent="dialogAddDoorphone = false"
          >
            Отменить
          </v-btn>
          <v-btn
            color="success"
            text
            :loading="loading"
            @click.prevent="bindControllerDoorphone()"
          >
            привязать
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BaseDeleteModal from '@/components/BaseDeleteModal';

export default {
  name: 'BindingDoorphone',
  props: ['id'],
  components: { BaseDeleteModal },
  data: () => {
    return {
      loading: false,
      attachedDoorphones: [],
      filteredDoorphone: [],
      address: '',
      dialogAddDoorphone: false,
      apartmentPrefix: [],
      selected: [],
      dialogRemove: {},
      isDisabled: true,
      popupBindDoorphones: false,
      isSelected: false,
      doorphones: [],
      selectedDoorphones: [],
      serchValue: '',
      serchValueId: '',
      doorphoneId: [],
      loadingListDoorphones: false,
      cachedListDoorphones: null,
      headersTieDoorphones: [
        { text: 'id', value: 'id' },
        { text: 'Адрес', value: 'address', sortable: false },
      ],
      headersAttachedDoorphones: [
        { text: 'id', value: 'id' },
        { text: 'Адрес', value: 'address', sortable: false },
        { text: '', value: 'actions', sortable: false },
      ],
      include: ['mainDoorphones'],
    };
  },
  created () {
  },
  computed: {
    ...mapGetters({
      doorphone: 'Doorphone/doorphoneEditDoorphone',
      controller: 'Controllers/controllerEdit',
      doorphonesArrays: 'Doorphone/doorphonesExpanded',
      roleName: 'roleName',
    }),
    searchFreeDoorphones () {
      if (this.serchValue) {
        return this.filteredDoorphone.filter(doorphone => {
          return doorphone.address.toString().toLowerCase().includes(this.serchValue.toLowerCase());
        });
      }

      if (this.serchValueId) {
        return this.filteredDoorphone.filter(item => {
          return item.id.toString().toLowerCase().includes(this.serchValueId.toLowerCase());
        });
      }
      if (this.attachedDoorphones) {
        return this.filteredDoorphone.filter(doorphone => {
          return !this.attachedDoorphones.includes(doorphone.id);
        });
      }
      return this.filteredDoorphone;
    },
    displayCardText () {
      return 'Привязанные домофоны.';
    },
    displayMain () {
      return !!(this.controller.doorphones[0] && this.$checkPermission('edit_controller'));
    },
    displayBindingController () {
      return this.$checkPermission('update_controller');
    },
  },
  methods: {
    ...mapActions({
      getDoorphones: 'Doorphone/getExpandedDoorphones',
      // getControllerInfoEdit: 'Controllers/getController',
      getControllerInfoEdit: 'Controllers/getControllerInfoEdit',
      updateController: 'Controllers/updateController',
    }),
    activateShowSelect (value) {
      const index = this.selected.indexOf(value);

      if (index === -1) {
        this.selected.push(value);
      } else {
        this.selected.splice(index, 1);
      }
      this.isDisabled = this.selected.length === 0;
    },
    async getData () {
      await this.getControllerInfoEdit({
        id: this.$route.params.id,
      })
        .then(() => {})
        .catch(() => {
          this.$flash_warning('Ошибка при загрузке информации');
        });
    },
    async getPossibleDoorphones () {
      if (this.cachedListDoorphones) {
        this.filteredDoorphone = this.cachedListDoorphones;
        this.popupBindDoorphones = true;
        return;
      }
      this.popupBindDoorphones = true;
      this.loadingListDoorphones = true;
      await this.loadDoorphones();
    },
    addDoorphone () {
      if (this.selected[0]) {
        this.doorphones.push(this.selected);
        this.dialogAddDoorphone = true;
      } else {
        this.$flash_danger('Выберите домофон');
      }
    },
    getDoorphoneAddress (doorphone) {
      let address = doorphone.address;
      if (doorphone.entrance > 0) {
        address = `${doorphone.address}, п.${doorphone.entrance}`;
      }
      return address;
    },
    excisionControllerDoorphone (idDelete) {
      const doorphoneId = this.controller.doorphones.map(item => item.id);
      const filteredArray = doorphoneId.filter(id => id !== idDelete);
      this.listDoorphonesdelete = filteredArray.length > 0 ? filteredArray : [];

      const tempController = {
        device_id: this.controller.controller.device_id,
        physical_status: this.controller.controller.physical_status,
        address: this.controller.controller.address,
        doorphones: this.listDoorphonesdelete,
      };
      if (this.controller.controller.region && this.isDistrict) {
        tempController.region_id = this.controller.controller.region;
      }
      if (this.controller.controller.name) {
        tempController.name = this.controller.controller.name;
      }
      this.updateController({
        id: this.$route.params.id,
        params: tempController,
      })
        .then(() => {
          this.$flash_success('Изменения успешно сохранены');
          this.getData();
        })
        .catch(() => {
          this.$flash_warning('Ошибка при редактирование контроллера');
        });
    },
    bindControllerDoorphone () {
      const doorphones = this.doorphones[this.doorphones.length - 1].slice();
      const doorphonesIdAttached = [];
      this.selectedDoorphones = doorphones.map(doorphone => ({
        id: doorphone.id,
        address: doorphone.address,
      }));
      if (this.controller.doorphones) {
        this.controller.doorphones.forEach(item => {
          doorphonesIdAttached.push(item.id);
        });
      }
      const doorphoneIds = this.selectedDoorphones.map(doorphone => doorphone.id);
      this.combinedArrayId = [...new Set([...doorphoneIds, ...doorphonesIdAttached])];
      const tempController = {
        device_id: this.controller.controller.device_id,
        physical_status: this.controller.controller.physical_status,
        address: this.controller.controller.address,
        doorphones: this.combinedArrayId,
      };
      if (this.controller.controller.region && this.isDistrict) {
        tempController.region_id = this.controller.controller.region;
      }
      if (this.controller.controller.name) {
        tempController.name = this.controller.controller.name;
      }

      this.loading = true;
      this.updateController({
        id: this.$route.params.id,
        params: tempController,
      })
        .then(() => {
          this.$flash_success('Домофон успешно Привязан');
          this.getData();
        })
        .catch((err) => {
          console.error(err);
          if (err.response && err.response.status === 422) {
            const error = err.response.data.gate;
            error.forEach(item => {
              this.$flash_danger('Ошибка: ' + item);
            });
          } else {
            this.$flash_warning('Ошибка при привязки домофона');
          }
          this.selectedDoorphones = this.selectedDoorphones.filter(doorphone => this.doorphoneId.includes(doorphone.id));
        })
        .finally(() => {
          // this.loading = true;
          this.cancelBindDoorphone();
        });
    },
    cancelBindDoorphone () {
      this.popupBindDoorphones = false;
      this.dialogAddDoorphone = false;
      this.cachedListDoorphones = null;
      this.loading = false;
      this.selected = [];
      this.selectedDoorphones = [];
      this.value = '';
      this.serchValue = '';
      this.serchValueId = '';
    },
    loadDoorphones () {
      this.getDoorphones({
        pagination: 1,
        limit: 9999,
        // уточнить модель домофона
        filters: { type: 'M' },
        include: this.include,
      })
        .then((data) => {
          this.totalDoorphones = data.meta.total;
          this.filteredDoorphone = this.doorphonesArrays;
          this.cachedListDoorphones = this.doorphonesArrays;
          if (this.controller.doorphones[0]) {
            this.attachedDoorphones = this.controller.doorphones.map(doorphone => doorphone.id);
          }
        })
        .catch((err) => {
          console.error(err);
          this.$flash_warning('Ошибка при загрузке домофонов');
        })
        .finally(() => {
          this.loadingListDoorphones = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.routerLink {
  text-decoration: none;
}

.v-application a {
  color: #434850;
}

.row-click {
  cursor: pointer;
}

a:hover.routerLink {
  text-decoration: underline;
}
</style>
